import { getExpirationFromDate } from '../../common/utils/dates'

const CLIENT_SECRET_EXPIRY_WARNING_DAYS = 15

export type ClientSecretExpirationStatus =
  | { type: 'expired' }
  | { type: 'expiring'; daysRemaining: number }
  | { type: 'notConfigured' }

export const getClientSecretExpirationStatus = (
  expirationDate: string | undefined,
  showNotConfiguredMessage = true
): ClientSecretExpirationStatus | null => {
  if (!expirationDate?.trim()) {
    return showNotConfiguredMessage ? { type: 'notConfigured' } : null
  }

  const { dayDiff, isExpired } = getExpirationFromDate(
    expirationDate,
    CLIENT_SECRET_EXPIRY_WARNING_DAYS,
    CLIENT_SECRET_EXPIRY_WARNING_DAYS
  )

  if (Number.isNaN(dayDiff)) {
    return showNotConfiguredMessage ? { type: 'notConfigured' } : null
  }

  if (isExpired || dayDiff < 0) {
    return { type: 'expired' }
  }

  const daysRemaining = dayDiff + 1

  if (daysRemaining <= CLIENT_SECRET_EXPIRY_WARNING_DAYS) {
    return { type: 'expiring', daysRemaining }
  }

  return null
}
